export default __webpack_public_path__ + "static/media/M53.95dde97b.svg";